// GrapesJS calls isComponent against text/comment nodes too, so guard before reading attributes.
export function safeElement(el: unknown): el is Element {
  return Boolean(el) && typeof (el as Element | null)?.getAttribute === 'function';
}
